/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_Feature_3Inputs */

const en_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintain core adblock, privacy, & speed`)
};

const id_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertahankan adblock, privasi, & kecepatan inti`)
};

const ms_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kekalkan adblock teras, privasi, & kelajuan`)
};

const ca_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manté el bloqueig d'anuncis bàsic, la privadesa i la velocitat`)
};

const cs_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udržujte základní blokování reklam, soukromí a rychlost`)
};

const da_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevar kerne-adblock, privatliv og hastighed`)
};

const de_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wesentlichen Adblocker, Datenschutz und Geschwindigkeit beibehalten`)
};

const et_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säilita põhiline reklaamiblokeerija, privaatsus ja kiirus`)
};

const es_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén el bloqueo de anuncios, la privacidad y la velocidad esenciales`)
};

const fr_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conserver le blocage des publicités, la confidentialité et la rapidité`)
};

const hr_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Održavajte osnovni adblock, privatnost i brzinu`)
};

const it_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni adblock, privacy e velocità di base`)
};

const lv_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzturiet reklāmu bloķēšanu, privātumu un ātrumu`)
};

const lt_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palaikykite pagrindines reklamų blokavimo, privatumo ir greičio funkcijas`)
};

const hu_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tartsd fenn az alapvető hirdetésblokkolást, adatvédelmet és sebességet`)
};

const nl_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onderhoud kernfunctionaliteit voor adblock, privacy en snelheid`)
};

const nb_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppretthold kjerne-adblock, personvern og hastighet`)
};

const pl_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utrzymuj podstawową blokadę reklam, prywatność i szybkość`)
};

const pt_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha o bloqueio de anúncios, privacidade e velocidade essenciais`)
};

const ro_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menține adblock-ul de bază, confidențialitatea și viteza`)
};

const sk_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zachovajte základné blokovanie reklám, súkromie a rýchlosť`)
};

const sl_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohranite osnovni adblock, zasebnost in hitrost`)
};

const fi_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ylläpidä mainosten esto, yksityisyys ja nopeus`)
};

const sv_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibehåll grundläggande adblock, integritet och hastighet`)
};

const vi_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duy trì khả năng chặn quảng cáo, quyền riêng tư và tốc độ cốt lõi`)
};

const tr_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temel reklam engelleme, gizlilik ve hızı koruyun`)
};

const el_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Διατηρήστε βασικό adblock, απόρρητο & ταχύτητα`)
};

const bg_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддържайте основната блокировка на реклами, поверителност и скорост`)
};

const ru_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраняйте основные функции блокировки рекламы, конфиденциальности и скорости`)
};

const sr_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одржавајте основни adblock, приватност и брзину`)
};

const uk_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтримуйте основну блокування реклами, приватність і швидкість`)
};

const ka_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეინარჩუნეთ ძირითადი რეკლამის დაბლოკვა, კონფიდენციალურობა და სიჩქარე`)
};

const hi_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य एडब्लॉक, गोपनीयता और गति बनाए रखें`)
};

const th_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คงไว้ซึ่งการบล็อกโฆษณา ความเป็นส่วนตัว และความเร็วระดับหลัก`)
};

const ko_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`핵심 광고 차단, 개인정보 보호 및 속도 유지`)
};

const zh_tw_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`維持核心廣告攔截、隱私與速度`)
};

const ja_origin_feature_3 = /** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主要な広告ブロック、プライバシー、スピードを維持`)
};

/** @type {(inputs: Origin_Feature_3Inputs) => LocalizedString} */
const zh_origin_feature_3 = en_origin_feature_3;

/**
* | output |
* | --- |
* | "Maintain core adblock, privacy, & speed" |
*
* @param {Origin_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const origin_feature_3 = /** @type {((inputs?: Origin_Feature_3Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_Feature_3Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_origin_feature_3(inputs)
	if (locale === "ms") return ms_origin_feature_3(inputs)
	if (locale === "ca") return ca_origin_feature_3(inputs)
	if (locale === "cs") return cs_origin_feature_3(inputs)
	if (locale === "da") return da_origin_feature_3(inputs)
	if (locale === "de") return de_origin_feature_3(inputs)
	if (locale === "et") return et_origin_feature_3(inputs)
	if (locale === "es") return es_origin_feature_3(inputs)
	if (locale === "fr") return fr_origin_feature_3(inputs)
	if (locale === "hr") return hr_origin_feature_3(inputs)
	if (locale === "it") return it_origin_feature_3(inputs)
	if (locale === "lv") return lv_origin_feature_3(inputs)
	if (locale === "lt") return lt_origin_feature_3(inputs)
	if (locale === "hu") return hu_origin_feature_3(inputs)
	if (locale === "nl") return nl_origin_feature_3(inputs)
	if (locale === "nb") return nb_origin_feature_3(inputs)
	if (locale === "pl") return pl_origin_feature_3(inputs)
	if (locale === "pt") return pt_origin_feature_3(inputs)
	if (locale === "ro") return ro_origin_feature_3(inputs)
	if (locale === "sk") return sk_origin_feature_3(inputs)
	if (locale === "sl") return sl_origin_feature_3(inputs)
	if (locale === "fi") return fi_origin_feature_3(inputs)
	if (locale === "sv") return sv_origin_feature_3(inputs)
	if (locale === "vi") return vi_origin_feature_3(inputs)
	if (locale === "tr") return tr_origin_feature_3(inputs)
	if (locale === "el") return el_origin_feature_3(inputs)
	if (locale === "bg") return bg_origin_feature_3(inputs)
	if (locale === "ru") return ru_origin_feature_3(inputs)
	if (locale === "sr") return sr_origin_feature_3(inputs)
	if (locale === "uk") return uk_origin_feature_3(inputs)
	if (locale === "ka") return ka_origin_feature_3(inputs)
	if (locale === "hi") return hi_origin_feature_3(inputs)
	if (locale === "th") return th_origin_feature_3(inputs)
	if (locale === "ko") return ko_origin_feature_3(inputs)
	if (locale === "zh") return zh_origin_feature_3(inputs)
	if (locale === "zh-tw") return zh_tw_origin_feature_3(inputs)
	if (locale === "ja") return ja_origin_feature_3(inputs)
	return en_origin_feature_3(inputs)
});